function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  width: "24",
  height: "24"
}, props), /*#__PURE__*/React.createElement("circle", {
  cx: "6.25",
  cy: "17.25",
  r: "4.25",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5"
}), /*#__PURE__*/React.createElement("rect", {
  width: "8",
  height: "8",
  x: "14",
  y: "13.25",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  rx: "2"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "1.5",
  d: "M16.248 10.5H8.752a1.25 1.25 0 01-1.06-1.912l3.748-6a1.25 1.25 0 012.12 0l3.748 6a1.25 1.25 0 01-1.06 1.912z",
  clipRule: "evenodd"
}));